import React, { useState } from "react";
import { DefaultButton } from "../button/defaultButton/DefaultButton";
import { Icon, IconType } from "../../icons/Icon";
import styles from "./CookieConsent.module.scss";

interface ICookieConsentProps {
  onAccept: () => void;
  onDecline: () => void;
}

export const CookieConsent: React.FC<ICookieConsentProps> = ({
  onAccept,
  onDecline,
}) => {
  const [isClosing, setIsClosing] = useState(false);

  const handleAccept = () => {
    setIsClosing(true);
    setTimeout(() => {
      onAccept();
    }, 300); // Match animation duration
  };

  const handleDecline = () => {
    setIsClosing(true);
    setTimeout(() => {
      onDecline();
    }, 300); // Match animation duration
  };

  return (
    <div className={`${styles.overlay} ${isClosing ? styles.closing : ''}`}>
      <div className={`${styles.popup} ${isClosing ? styles.closing : ''}`}>
        <div className={styles.header}>
          <div className={styles.icon}>
            <Icon type={IconType.Cookie} className={styles.cookieIcon} />
          </div>
          <h3 className={styles.title}>Кой обича бисквитки? 🍪</h3>
        </div>

        <div className={styles.content}>
          <p className={styles.text}>
            Използваме бисквитки, за да подобрим изживяването Ви. Те ни помагат
            да анализираме как използвате сайта и да го направим още по-добър за
            Вас.
          </p>
          <p className={styles.subtext}>
            Можете да управлявате настройките си по всяко време.
          </p>
        </div>

        <div className={styles.actions}>
          <DefaultButton
            label="Приемам бисквитките"
            onClick={handleAccept}
            className={styles.acceptButton}
          />
          <DefaultButton
            label="Не, благодаря"
            onClick={handleDecline}
            design="outline"
            className={styles.declineButton}
          />
        </div>
      </div>
    </div>
  );
};
